import { h } from 'preact';

var GeoSearchButton = function GeoSearchButton(param) {
    var className = param.className, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ h("button", {
        className: className,
        onClick: onClick,
        disabled: disabled
    }, children);
};

export { GeoSearchButton as default };
